import { KnmErpFormFieldsNamesTemplatesEnum } from '../enums/KnmErpFormFieldsNamesTemplatesEnum';

export const knmErpErrorFieldsArrangeArray: Array<KnmErpFormFieldsNamesTemplatesEnum> = [
  KnmErpFormFieldsNamesTemplatesEnum.TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.KIND,
  KnmErpFormFieldsNamesTemplatesEnum.SUBJECT_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.ORDER_NUMBER,
  KnmErpFormFieldsNamesTemplatesEnum.ORDER_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.HEAD_ORDER_NUMBER,
  KnmErpFormFieldsNamesTemplatesEnum.START_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.STOP_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.MONTH,
  KnmErpFormFieldsNamesTemplatesEnum.LEGAL_BASES,
  KnmErpFormFieldsNamesTemplatesEnum.AUDITED_PERSON_AUTHORITY,
  KnmErpFormFieldsNamesTemplatesEnum.AUDITED_PERSON_AUTHORITY_OBJECT,
  KnmErpFormFieldsNamesTemplatesEnum.REQUIREMENTS,
  KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_OBJECT,
  KnmErpFormFieldsNamesTemplatesEnum.CHECKLIST_ERVK,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTION_TARGET,
  KnmErpFormFieldsNamesTemplatesEnum.DURATION_DAYS,
  KnmErpFormFieldsNamesTemplatesEnum.DURATION_HOURS,
  KnmErpFormFieldsNamesTemplatesEnum.EVENTS,
  KnmErpFormFieldsNamesTemplatesEnum.EVENT_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.EVENT_START_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION,
  KnmErpFormFieldsNamesTemplatesEnum.REASONS_ERVK,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_TYPE_ERVK,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_ORDER_ERVK,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS,
  KnmErpFormFieldsNamesTemplatesEnum.REASONS_ERP_RISK_INDICATOR,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_FULLNAME,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_ERVK_FULLNAME,
  KnmErpFormFieldsNamesTemplatesEnum.INSPECTOR_ERVK_POSITION,
  KnmErpFormFieldsNamesTemplatesEnum.SUPERVISION_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.COLLABORATING_KNO_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATION_ORGANIZATION,
  KnmErpFormFieldsNamesTemplatesEnum.PROSECUTOR_ORGANIZATION,
  KnmErpFormFieldsNamesTemplatesEnum.REASONS,
  KnmErpFormFieldsNamesTemplatesEnum.REASON,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_TEXT,
  KnmErpFormFieldsNamesTemplatesEnum.REASON_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.APPROVE_ORDER_NUMBER,
  KnmErpFormFieldsNamesTemplatesEnum.REJECT_REASON_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.REJECT_REASON_TEXT,
  KnmErpFormFieldsNamesTemplatesEnum.DECISION_PLACE,
  KnmErpFormFieldsNamesTemplatesEnum.SIGNER_FULL_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.SIGNER_POSITION,
  KnmErpFormFieldsNamesTemplatesEnum.OGRN,
  KnmErpFormFieldsNamesTemplatesEnum.INN,
  KnmErpFormFieldsNamesTemplatesEnum.ORGANIZATION_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_ADDRESS,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_OBJECT_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ERVK_ADDRESS_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_SUPERVISION,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_OBJECT,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_CREATE_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_ADDRESS,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ACT_ADDRESS_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_START_DATE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DURATION_DAYS,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DURATION_HOURS,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_FULL_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_POSITION,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_INSPECTOR_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_FULL_NAME,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_POSITION,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_DELEGATE_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ADDITIONAL_INFO_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.OBJECT_RESULT_ADDITIONAL_INFO_INFORMATION,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_RESULT,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_NOTE,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_VIOLATION,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_ITEM_LAWSUIT_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.VIOLATION_LAWSUIT_ITEM_TEXT,
  KnmErpFormFieldsNamesTemplatesEnum.RESULT_CANCELLATION_INFO_RESULT,
  KnmErpFormFieldsNamesTemplatesEnum.RESULT_CANCELLATION_INFO_INFORMATION,
  KnmErpFormFieldsNamesTemplatesEnum.DOCUMENT_TYPE,
  KnmErpFormFieldsNamesTemplatesEnum.FORM_LINK_TYPE,
];
